import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib_api';

export default function AiPolicies() {
  const qc = useQueryClient();
  const policies = useQuery({ queryKey: ['admin', 'ai', 'policies'], queryFn: async () => (await api.get('/api/ai/admin/policies')).data });
  const update = useMutation({
    mutationFn: async ({ featureKey, enabled }: { featureKey: string; enabled: boolean }) => (await api.patch(`/api/ai/admin/policies/${featureKey}`, { enabled })).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'ai', 'policies'] }),
  });

  return (
    <section className="space-y-4">
      <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-darkCard dark:bg-darkCard/60">
        <h3 className="text-sm font-semibold">AI Feature Policies</h3>
      </div>
      {(policies.data?.items || []).map((item: any) => (
        <div key={item.featureKey} className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white p-4 dark:border-darkCard dark:bg-darkCard/60">
          <div>
            <div className="font-medium">{item.featureKey}</div>
            <div className="text-xs text-mutedGray">Primary model: {item.policy?.model_primary} · Cooldown: {item.policy?.cooldown_seconds}s</div>
          </div>
          <button className="rounded-md border px-3 py-1" onClick={() => update.mutate({ featureKey: item.featureKey, enabled: !item.enabled })}>
            {item.enabled ? 'Disable' : 'Enable'}
          </button>
        </div>
      ))}
    </section>
  );
}
